import { createErrorTransformer } from 'store/queries/utils.ts'
import { Flow } from 'types/logging.ts'
import { boltBackend } from '../index.ts'
import { GetDiscountsResponseBody } from '@boltenergy-be/shared'

export const discountsBoltBackend = boltBackend.injectEndpoints({
  endpoints: (builder) => ({
    // GET DISCOUNTS
    getDiscounts: builder.query<GetDiscountsResponseBody, void>({
      query: () => '/resources/discounts',
      transformResponse: ({ data }) => data,
      transformErrorResponse: createErrorTransformer(`[${Flow.DISCOUNTS}:getDiscounts]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDiscountsQuery } = discountsBoltBackend
